//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TransientObject.js";
import "../no/ugmath.js";
let d=[[[0,"CenterPoint",0,0],[0,"EndAngle",0,0],[0,"Index",0,0],[0,"Radius",0,0],[0,"StartAngle",0,0],[0,"Type",0,0]],[[[],"Dispose",{},0,0]],[]];
SPLM.Annotations.ArcComponent = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.ArcComponent";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.ArcComponent.ArcType = Object.freeze({
    "Extension" : "Extension", "Dimension" : "Dimension", "AllAround" : "AllAround", "Annotation" : "Annotation", "Inspection" : "Inspection", "AllOver" : "AllOver", "GbDatum" : "GbDatum"});

export default SPLM;